import React from "react"

const PageHead = ({ seo }) => {
  if (seo.robots === undefined) {
    seo.robots = "index,follow"
  }
  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.metaDesc} />
      <meta name="robots" content={seo.robots} />
      seo.canonical && <link rel="canonical" href={seo.canonical} />
    </>
  )
}

export default PageHead
